"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.TestLogger = void 0;
const abstractStringLogger_1 = require("./abstractStringLogger");
/**
 * A logger for unit tests, providing a callback to verify logged messages.
 */
class TestLogger extends abstractStringLogger_1.AbstractStringLogger {
    /**
     * Initializes a new instance of the @see TestLogger class.
     * @param minimumLevel The minimum log level this logger accepts for log messages.
     * @param callback Callback used to return log entry.
     */
    constructor(minimumLevel, callback) {
        super(minimumLevel);
        this.callback = callback;
    }
    /**
     * The real handler for log entries.
     * @param logLevel Entry will be written on this level.
     * @param requestId Guid of the request.
     * @param state The entry to be written. Can be also an object.
     * @param error The error related to this entry.
     * @param formatter Function to create a string message of the state and error.
     */
    logHandler(logLevel, requestId, state, error, formatter) {
        if (this.callback) {
            this.callback(logLevel, requestId, state, error);
        }
    }
}
exports.TestLogger = TestLogger;
//# sourceMappingURL=testLogger.js.map